// Webpack Imports
import * as bootstrap from 'bootstrap';
import * as $ from 'jquery';

import '@fortawesome/fontawesome-free/js/fontawesome.js';
import '@fortawesome/fontawesome-free/js/solid.js';
import '@fortawesome/fontawesome-free/js/brands.js';
import { Splide } from '@splidejs/splide';
import AOS from 'aos';

let currentStep = 'material';

( function () {
	'use strict';

	if ($('.variations').length) {
		$('.accordion-body').css('height', (window.innerHeight - 650) + 'px');
		$('body').addClass('variable');
		$('.woocommerce-product-gallery').css('min-height', (window.innerHeight - 200) + 'px');
	}

	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl)
	});

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	renderList();

	$('.next').on('click', function() {
		if (currentStep == 'material' && $('#pa_material').val() == '') {
			alert('Veuillez sélectioner un matériaux')
		} else {
			currentStep == 'format';
		}
		if (currentStep == 'format' && $('#pa_format').val() == '') {
			alert('Veuillez sélectioner un format')
		}
	})

	$('.variation-item').on('click', function () {
		const el = $(this);
		el.parent().find('.variation-item').removeClass('active');
		el.addClass('active');
		const val = el.attr('data-id');
		const select = el.parent().find('select');
		select.val(val);
		select.trigger('change');

		let material = $('#pa_material').val();
		let color = $('#pa_color').val();
		let format = $('#pa_format').val();

		updateList(material);
		
		if (el.hasClass('pa_material')) {
			$('#selected-material').html(el.find('.variation-name').html());
		}
		if (el.hasClass('pa_color')) {
			$('#selected-color').html(el.find('.variation-name').html());
		}
		if (el.hasClass('pa_format')) {
			$('#selected-format').html(el.find('.variation-name').html());
		}
		// TODO : ajouter le param color si ca influe sur le prix
		let variation = getVariation(material, format);
		if (variation != null) {

			console.log(variation);
			
			$('.price').html(priceHTML(variation.display_price));

			$('.single_variation').show();
			$('.variations_button').removeClass('woocommerce-variation-add-to-cart-disabled');
			$('.variation_id').val(variation.variation_id);
		} else {
			$('.variations_button').addClass('woocommerce-variation-add-to-cart-disabled');
		}
	});
} )();

function renderList() {

	$('.variations .accordion-body').each(function() {
		const el = $(this);
		const options = el.find('.variation-item');
		options.each(function () {
			const opt = $(this);
			let vari = null;
			APP_VARIATION.forEach(item => {
				if (item.attributes.attribute_pa_material == opt.attr('data-id') && vari == null) {
					vari = item;
				}
			});
			if (vari != null) {
				opt.find('.variation-price').html(priceHTML(vari.display_price));
			}
		});
	});

	// TODO
	// --> fonction du btn "suivant"
	// --> empêcher la sélection du format et couleur avant le matériaux
}

function updateList(material) {
	$('.pa_color').each(function () {
		const el = $(this);
		const color = el.attr('data-id');
		let vari = null;
		APP_VARIATION.forEach(item => {
			if (item.attributes.attribute_pa_material == material && item.attributes.attribute_pa_color == color) {
				vari = item;
			}
		});
		if (vari != null) {
			el.show();
			el.find('.variation-price').html(priceHTML(vari.display_price));
		} else {
			el.hide();
		}
	});
	$('.pa_format').each(function(){
		const el = $(this);
		const format = el.attr('data-id');
		let vari = null;
		APP_VARIATION.forEach(item=>{
			if (item.attributes.attribute_pa_material == material && item.attributes.attribute_pa_format == format) {
				vari = item;
			}
		});
		if (vari != null) {
			el.show();
			el.find('.variation-price').html(priceHTML(vari.display_price));
		} else {
			el.hide();
		}
	});
}

if ($('.productsSlider').length > 0) {
	new Splide('.productsSlider').mount();
}

function getVariation(material, format) {
	let attr = null;
	// console.log(material);
	APP_VARIATION.forEach(item=>{
		// console.log(item.attributes);
		if (item.attributes.attribute_pa_format == format && item.attributes.attribute_pa_material == material) {
			attr = item;
		}
	});
	return attr;
}

function priceHTML(val) {
	return parseFloat(val).toFixed(2).replace('.',',')+'€';
}

$(function () {

	AOS.init();

	if ($('.headerSlider').length > 0) {
		var splide = new Splide('.headerSlider', {
			type: 'loop',
			perPage: 1,
			focus: 'center',
			autoplay: true
		});
		splide.mount();
	}

	if ($('.productsSlider').length > 0) {
		var splide = new Splide('.productsSlider', {
			perPage: 4,
			perMove: 2,
			autoplay: true,
			pagination: false,
			breakpoints: {
				768: {
					perPage: 2,
				},
				991: {
					perPage: 3,

				},
				1024: {
					perPage: 4
				},
			}
		});
		splide.mount();
	}
	if ($('.headSlider').length > 0) {
		var splide = new Splide('.headSlider', {
			perPage: 1,
			autoplay: true,
			pagination: false
		});
		splide.mount();
	}

	$('.toggleFilters').on('click', ()=>{
		$('#products_filters').toggleClass('active')
	});

});